import { ALERTS, get, post } from "./Client";
import { useSelector } from "react-redux";
import { useQuery } from "react-query";

export function useGetAlerts(open) {
    let project = useSelector(store => store.session.project)
    let params = project ? { project: project.id } : null
    if (open !== undefined) params.open = open
    const { status, data, error } = useQuery(['alerts', params], () =>
        get(`${ALERTS}`, { params }),
        { enabled: !!project }
    );
    return { status, alerts: data || [], error }
}

export function alertChangeNote(alertId, note) {
    return post(`${ALERTS}/${alertId}/note`, { body: note, headers: { "Content-Type": "text/plain" } })
}

export function alertClose(alertId, silUntil) {
    return post(`${ALERTS}/${alertId}/close`, { params: { silUntil } })
}
